///<reference path="BaseScreen.ts"/>
namespace nscs.screen {

    export class PauseScreen extends BaseScreen {

        public onQuit:()=>void;
        public onResume:()=>void;

        constructor(scene:Phaser.Scene) {
            super(scene);

            //---------------------pause---------------------//
            let bg = new Phaser.GameObjects.Graphics(this.scene);
            bg.setPosition(0, 0);
            bg.fillStyle(0x000000, 0.4);
            bg.fillRect(0, 0, game.scale.width, game.scale.height);
            this.add(bg);
            let GamePaused_txt:Phaser.GameObjects.Text = this.scene.add.text(game.scale.width/2, game.scale.height/2-25, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 33,
                "color": "#FFFFFF",
                "align": 'center'
            });
            GamePaused_txt.setOrigin(0.5, 0.5);
            GamePaused_txt.setStroke('#000000', 5);
            this.add(GamePaused_txt);
            nscs.gameplay.Gameplay.setText(GamePaused_txt, 'Paused');

            let _QuitBtn:Phaser.GameObjects.Image = new Phaser.GameObjects.Image(this.scene, 139, 194, 'ui-atlas', 'btn_next_story'+'0000');
            this.add(_QuitBtn);
            let QuitBtn_txt:Phaser.GameObjects.Text = this.scene.add.text(_QuitBtn.x, _QuitBtn.y-5, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 19,
                "color": "#FFFFFF",
                "align": 'center'
            });
            QuitBtn_txt.setOrigin(0.5, 0.5);
            this.add(QuitBtn_txt);
            nscs.gameplay.Gameplay.setText(QuitBtn_txt, 'QuitBtn');

            let _ResumeBtn:Phaser.GameObjects.Image = new Phaser.GameObjects.Image(this.scene, 354, 194, 'ui-atlas', 'btn_next_story'+'0000');
            this.add(_ResumeBtn);
            let Resume_txt:Phaser.GameObjects.Text = this.scene.add.text(_ResumeBtn.x, _ResumeBtn.y-5, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 19,
                "color": "#FFFFFF",
                "align": 'center'
            });
            Resume_txt.setOrigin(0.5, 0.5);
            this.add(Resume_txt);
            nscs.gameplay.Gameplay.setText(Resume_txt, 'ResumeBtn');

            _QuitBtn.setInteractive({cursor: 'pointer'});
            _QuitBtn.on('pointerup', ()=>{
                this.onQuit();
                nscs.sound.SoundManager.getInstance().playSound('winnerSND');
            });
            _QuitBtn.on('pointerover', () => {
                nscs.sound.SoundManager.getInstance().playSound('whistleSND');
            });
            _QuitBtn.setScrollFactor(0);
            _ResumeBtn.setInteractive({cursor: 'pointer'});
            _ResumeBtn.on('pointerup', ()=>{
                this.onResume();
                nscs.sound.SoundManager.getInstance().playSound('winnerSND');
            });
            _ResumeBtn.on('pointerover', () => {
                nscs.sound.SoundManager.getInstance().playSound('whistleSND');
            });
            _ResumeBtn.setScrollFactor(0);

            this.hidePauseGame();
        }

        public showPauseGame():void {
            this.visible = true;
        }

        public hidePauseGame():void {
            this.visible = false;
        }
    }
}